"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeStage = exports.questionConditionalMet = void 0;
console.time("Load stage");
var json_1 = require("../util/json");
var util_1 = require("./util");
/** Returns true based on conditional is met or does not exist,
 * returns false if conditional is present and not met */
function questionConditionalMet(def, infoKeys, orgMetadata, screenerMetadata, options) {
    // Check for metadata conditional
    if (def["Field Type"] !== "Validated" && def['Metadata']) {
        var metadata = (0, json_1.safeParse)(def['Metadata'] || '{}');
        if (metadata.conditional) {
            var result = (0, util_1.evalConditional)(metadata.conditional, infoKeys, orgMetadata, screenerMetadata, options);
            return result;
        }
    }
    var conditionalOn = def["Conditional On"];
    if (!conditionalOn)
        return true;
    var conditionalOnValue = def["Conditional On Value"];
    if ((!conditionalOnValue || conditionalOnValue.length === 0) && !infoKeys[conditionalOn])
        return false;
    if ((conditionalOnValue && conditionalOnValue.length > 0) && conditionalOnValue.indexOf(infoKeys[conditionalOn] || '!!do_not_set_a_value_to_this!!') < 0) {
        return false;
    }
    return true;
}
exports.questionConditionalMet = questionConditionalMet;
/** Automated in the sense that they are not required to advance a stage */
var AUTOMATED_QUESTIONS = ['Flag', 'Flag Review', 'Correction Request', 'Show Field', 'Show Date', 'Notification'];
/** Stage progression is based on whether all required keys [in a stage] are satisfied */
function computeStage(infoKeys, infoDefs, orgMetadata, screenerMetadata, options) {
    /**
    ### Holds the state of the stage computation
    */
    var state = { isIneligible: false, isUnreachable: false, isOptedOut: false, currentStage: '' };
    /**
     ### The set of missing info stages with their missing target fields.
     */
    var missingInfo = {};
    /**
    ### List to hold missing info stages. We grab the first one later to know which one to print.
    */
    var missingInfoStages = [];
    /**
    ### Adds missing info to the state
    */
    var addMissingInfo = function (stage, targetField) {
        if (!missingInfo[stage])
            missingInfo[stage] = new Set();
        missingInfo[stage].add(targetField);
        if (missingInfoStages.indexOf(stage) < 0) {
            missingInfoStages.push(stage);
        }
    };
    /**
    ### Checks if the answer provided for a Select question is disqualifying or missing info in the 'other' case.
    */
    var checkDisqualifyingOptions = function (question) {
        var e_1, _a;
        var key = question["Target Field"];
        try {
            for (var _b = __values((question["Options (if relevant)"] || [])), _c = _b.next(); !_c.done; _c = _b.next()) {
                var option = _c.value;
                if (infoKeys[key] === option['Name']) {
                    if (option['Name'] === 'other' || option['Other Field']) {
                        var otherInfo = infoKeys[key + "_" + option['Name']];
                        if (otherInfo && otherInfo.length > 0) {
                            return; // Reqs satisfied for this question
                        }
                        addMissingInfo(state['currentStage'], key);
                    }
                    if (option['Terminates Application']) {
                        state.isIneligible = true;
                    }
                    if (option['Marks Unreachable']) {
                        state.isUnreachable = true;
                    }
                    if (option['Marks Opted Out']) {
                        state.isOptedOut = true;
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
    ### Return true to continue, return false to keep trying other things.
    */
    var skipQuestion = function (question) {
        // Skip requiring a conditional question if conditions are not met
        if (!questionConditionalMet(question, infoKeys, orgMetadata, screenerMetadata, options)) {
            return true;
        }
        if (AUTOMATED_QUESTIONS.indexOf(question["Field Type"]) !== -1) {
            return true;
        }
        if ((question["Additional Options"] || []).indexOf('Optional') !== -1) {
            // it may be optional but it may also include a terminating answer, so check that
            if (['Single Select', 'Multiple Select'].indexOf(question["Field Type"]) !== -1) {
                checkDisqualifyingOptions(question);
            }
            return true;
        }
        // Skip card management req if we have a target field and card id
        if (question["Field Type"] === 'Card Management' && infoKeys[question["Target Field"] + "_id"]) {
            return true;
        }
        // Check if the section for this question is conditional
        if (question['Section'] && (question.Section["Conditional On"] || question.Section["Metadata"])) {
            if (!questionConditionalMet(question.Section, infoKeys, orgMetadata, screenerMetadata)) {
                return true;
            }
        }
    };
    // Do this in a closure, so we can use return to break out of both loops
    /** Computes the stage */
    var compute = function () {
        var e_2, _a, e_3, _b;
        for (var key in infoDefs) {
            var question = infoDefs[key];
            if (question.type === 'Correction Request' && (infoKeys[key] || '').length > 0) {
                return ["Correction Requested"];
            }
        }
        try {
            for (var _c = __values(Object.values(infoDefs).filter(function (d) { return d.type === 'Stage'; }).sort(function (a, b) {
                return a.sequence - b.sequence;
            })), _d = _c.next(); !_d.done; _d = _c.next()) {
                var stage_1 = _d.value;
                try {
                    // console.log("# of Requirements for stage " + stage.name + ": ", (stage.requirements || []).length);
                    // if (stage.name?.indexOf("Month 1") !== -1) {
                    //    console.log("Requirements for stage " + stage.name + ": ", stage.requirements || []);
                    //}
                    for (var _e = (e_3 = void 0, __values((stage_1.requirements || []))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var question = _f.value;
                        if (skipQuestion(question)) {
                            //if (question["Field Type"] === 'Payment' && (question.Question || '').indexOf("First") !== -1) {
                            //    console.log("Skipping question: ", question.Question)
                            //}
                            continue;
                        }
                        var key = question["Target Field"];
                        if (!key)
                            continue;
                        if (question["Field Type"] === 'Validated' && infoKeys[key + "_error"]) {
                            if ((question["Additional Options"] || []).indexOf('Marks Ineligible') !== -1) {
                                return ['Ineligible'];
                            }
                        }
                        if (key in infoKeys) {
                            // Just run this, it will return quickly if there are no options for this question
                            checkDisqualifyingOptions(question);
                            if ((infoKeys[key] || '').length === 0) {
                                addMissingInfo(state.currentStage, key);
                            }
                            if (state.isIneligible)
                                return ["Ineligible"];
                            if (state.isOptedOut)
                                return ["Opted Out"];
                            if (state.isUnreachable)
                                return ["Unreachable"];
                        }
                        else {
                            addMissingInfo(state.currentStage, key);
                        }
                        if ((question["Field Type"] === 'Contract Signer' && infoKeys[key] !== 'signed') ||
                            (question["Field Type"] === 'Contract Stale' && infoKeys[key] === 'stale')) {
                            addMissingInfo(state.currentStage, key);
                        }
                        if (question["Field Type"] === 'Correction Resolver' && key in infoKeys) {
                            addMissingInfo(state.currentStage, key);
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                // console.log("Updating currentStage state to: " + stage.name);
                state.currentStage = stage_1.name || stage_1.key;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        // TODO: Print missing info to log
        for (var stage_2 in missingInfo) {
            if (missingInfoStages.length && stage_2 !== missingInfoStages[0]) {
                continue;
            }
            // console.log(`${stage} is missing info: `, missingInfo[stage]);
        }
        // Return missingInfoStages or the current stage.
        if (missingInfoStages.length > 0) {
            return missingInfoStages;
        }
        return [state.currentStage];
    };
    var currentStages = compute();
    if (true || (options === null || options === void 0 ? void 0 : options.logMissingInfo)) {
        console.debug("Missing info: ", missingInfo);
    }
    // console.log("state of computeStage: ", state);
    var stage = currentStages[0];
    if (state.isIneligible) {
        stage = "Ineligible";
    }
    else if (state.isUnreachable) {
        stage = "Unreachable";
    }
    else if (state.isOptedOut) {
        stage = "Opted Out";
    }
    return {
        stage: stage,
        missingInfo: missingInfo
    };
}
exports.computeStage = computeStage;
console.timeEnd("Load stage");
